import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import SireInputAndList from '../components/MatingPlan/SireInputAndList';
import CowSelectionList from '../components/MatingPlan/CowSelectionList';
import MatingPlanResult from '../components/MatingPlan/MatingPlanResult';

const MatingPlanPage = ({ planState, setPlanState, selectedFarm, setDialog }) => {
    const [currentStep, setCurrentStep] = useState(1);
    const totalSteps = 3;

    const handleNext = () => {
        if (currentStep === 1 && planState.selectedSires.length === 0) {
            setDialog({ isOpen: true, title: "경고", message: "씨수소를 1개 이상 선택해야 합니다.", onClose: () => setDialog({ isOpen: false }) });
            return;
        }
        if (currentStep === 2 && planState.selectedCows.length === 0) {
            setDialog({ isOpen: true, title: "경고", message: "대상 암소를 1마리 이상 선택해야 합니다.", onClose: () => setDialog({ isOpen: false }) });
            return;
        }
        setCurrentStep(prev => Math.min(prev + 1, totalSteps));
    };

    const handlePrev = () => {
        setCurrentStep(prev => Math.max(prev - 1, 1));
    };

    const handleTabClick = (targetStep) => {
        // 이전 단계로 이동하는 것은 항상 허용
        if (targetStep < currentStep) {
            setCurrentStep(targetStep);
            return;
        }

        // 다음 단계로 이동 시 조건 확인
        if (targetStep > 1 && planState.selectedSires.length === 0) {
            setDialog({ isOpen: true, title: "경고", message: "씨수소를 1개 이상 선택해야 합니다.", onClose: () => setDialog({ isOpen: false }) });
            return;
        }
        if (targetStep > 2 && planState.selectedCows.length === 0) {
            setDialog({ isOpen: true, title: "경고", message: "대상 암소를 1마리 이상 선택해야 합니다.", onClose: () => setDialog({ isOpen: false }) });
            return;
        }

        // 모든 조건을 만족하면 해당 단계로 이동
        setCurrentStep(targetStep);
    };

    const renderStepContent = () => {
        switch (currentStep) {
            case 1:
                return <SireInputAndList
                    planState={planState}
                    setPlanState={setPlanState}
                    setDialog={setDialog}
                    selectedFarm={selectedFarm}
                    onNext={handleNext}
                    nextLabel="다음 단계"
                />;
            case 2:
                return <CowSelectionList
                    planState={planState}
                    setPlanState={setPlanState}
                    selectedFarm={selectedFarm}
                    setDialog={setDialog}
                    onNext={handleNext}
                    nextLabel="계획교배 실행"
                />;
            case 3:
                return <MatingPlanResult
                    planState={planState}
                    setPlanState={setPlanState}
                    selectedFarm={selectedFarm}
                    filters={planState.filters} // setDialog prop 전달
                    setDialog={setDialog}
                />;
            default:
                return <div>알 수 없는 단계입니다.</div>;
        }
    };

    return (
        <div className="page-content" style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
            <h2 className="page-title">계획교배 실행</h2>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '0.875rem', fontWeight: '500' }}>
                {[
                    { step: 1, name: '씨수소 선택/입력' },
                    { step: 2, name: '대상 암소 선택' },
                    { step: 3, name: '실행 결과' },
                ].map(item => (
                    <div
                        key={item.step}
                        onClick={() => handleTabClick(item.step)}
                        style={{
                            flex: 1,
                            textAlign: 'center',
                            padding: '0.5rem 0',
                            borderBottom: '4px solid',
                            transition: 'border-color 0.3s',
                            cursor: 'pointer',
                            borderColor: currentStep === item.step ? '#4f46e5' : '#e5e7eb',
                            color: currentStep === item.step ? '#4f46e5' : '#6b7280',
                            fontWeight: currentStep === item.step ? 'bold' : 'normal',
                        }}
                    >
                        Step {item.step}. {item.name}
                    </div>
                ))}
            </div>

            <div style={{ backgroundColor: 'white', padding: '1.5rem', borderRadius: '0.5rem', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)', minHeight: '400px' }}>
                {renderStepContent()}
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-start', paddingTop: '1rem' }}>
                <button
                    onClick={handlePrev}
                    disabled={currentStep === 1}
                    className="secondary-button"
                    style={{ padding: '0.75rem 1.5rem' }}
                >
                    <ChevronLeft size={20} style={{ marginRight: '0.5rem' }} /> 이전 단계
                </button>
            </div>
        </div>
    );
};

export default MatingPlanPage;
